import { type SelectContractorSameOrNewOption } from "./type";

export const selectContractorSameOrNewFormTestId =
  "components/fragments/forms/argyle/shipment-form/SelectSameContractor";
export const selectContractorSameOrNewFormSelectTestId =
  "components/fragments/forms/argyle/shipment-form/SelectSameContractor-select";
export const selectContractorSameOrNewFormLabelTestId =
  "components/fragments/forms/argyle/shipment-form/SelectSameContractor-label";

export const selectContractorSameOrNewField = "shipment.isSameContractor";

export const selectContractorSameOrNewOptions: SelectContractorSameOrNewOption[] = [
  {
    label: "ご契約者情報と同じ",
    value: "same",
  },
  {
    label: "別のお届け先を指定する",
    value: "new",
  },
];
